import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCallerCodeUrl } from "../utils/urlHelper";

const createCallerCodeApi = createApi({
  reducerPath: "createCallerCode",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    createCallerCode: builder.mutation({
      query: (body) => ({
        url: getCallerCodeUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useCreateCallerCodeMutation,
} = createCallerCodeApi;

export { createCallerCodeApi };
